import { useEffect, useRef } from 'react';

type ConvertHeicToAnyOptions = {
  blob: File;
  multiple?: true;
  toType?: string;
  quality?: number;
  gifInterval?: number;
};

export default function useHeic2any() {
  // 初始化heic2any库
  const heic2anyLib = useRef<
    ((options: ConvertHeicToAnyOptions) => Promise<Blob | Blob[]>) | null
  >(null);

  useEffect(() => {
    const loadLibrary = async () => {
      try {
        const heic2any = await import('heic2any');
        heic2anyLib.current = heic2any.default;
      } catch (error) {
        console.error('Failed to load heic2any library:', error);
      }
    };
    loadLibrary();
  }, []);

  // 转换heic文件到任意格式，参数见heic2any库的文档
  const convertHeicToAny = async ({
    blob,
    toType,
    quality,
    gifInterval,
    multiple,
  }: ConvertHeicToAnyOptions) => {
    if (!heic2anyLib.current) {
      throw new Error('heic2any library not loaded');
    }

    try {
      const convertedBlob = await heic2anyLib.current({
        blob,
        toType,
        quality,
        gifInterval,
        multiple,
      });

      const blobPart = Array.isArray(convertedBlob)
        ? convertedBlob[0]
        : convertedBlob;

      return new File(
        [blobPart],
        blob.name.replace(
          /\.heic$/,
          toType?.split('/')[1] ? '.' + toType?.split('/')[1] : '.png'
        ),
        {
          type: toType || 'image/png',
        }
      );
    } catch (error) {
      throw error;
    }
  };

  return { convertHeicToAny };
}
